import React, { Component, Fragment } from 'react'
import { compose } from 'recompose'
import withLoadingSection from '../../../elements/HOC/withLoadingSection'
import List from './List'
import FilesModal from './Modal/Files'

class Documents extends Component {
  render() {
    const {
      handleCancel,
      owner,
      file,
      editable,
      category,
      visible,
      type,
      fetch,
      email,
      emailLabel,
      linkTo,
      linkToType,
    } = this.props
    return (
      <Fragment>
        <FilesModal
          {...{
            key: file._key,
            owner,
            file,
            type,
            fetch,
            editable,
            category,
            email,
            emailLabel,
            visible,
            handleCancel,
            linkTo,
            linkToType,
          }}
        />
        <List {...this.props} />
      </Fragment>
    )
  }
}

Documents.propTypes = {}
Documents.defaultProps = {}

export default compose(withLoadingSection)(Documents)
